export default __webpack_public_path__ + "static/media/F0006.5ebebba2.png";